module.exports = ".custom-modal-container {\r\n            padding: 15px;\r\n            /*width: 400px;\r\n              height: 400px;*/\r\n        }\r\n\r\n        .custom-modal-header {\r\n            background-color: #219161;\r\n            color: #fff;\r\n            -webkit-box-shadow: 0px 3px 5px 0px rgba(0,0,0,0.75);\r\n            box-shadow: 0px 3px 5px 0px rgba(0,0,0,0.75);\r\n            margin-top: -15px;\r\n            margin-bottom: 40px;\r\n        }"


//////////////////
// WEBPACK FOOTER
// ./src/app/user/user-register/RegistrationPopup/user-info/user-info.component.css
// module id = ./src/app/user/user-register/RegistrationPopup/user-info/user-info.component.css
// module chunks = main